<template>
  <nav v-if="totalPages > 0">
    <ul class="pagination pagination-sm pt-1">
      <li class="page-item" :class="{ 'disabled': disablePreviousButton }">
        <a class="page-link" href="javascript:void(0);" tabindex="-1" @click="previous">{{$lang.Common.DataTable.Previous}}</a>
      </li>
      <li
        class="page-item"
        v-for="page in totalPages"
        v-if="canShowPage(page)"
        :key="page"
        :class="{ 'disabled': page === currentPage }"
        @click="to(page)"
      >
        <a class="page-link" href="javascript:void(0)">
          {{ page }}
        </a>
      </li>
      <li class="page-item" :class="{ 'disabled': disableNextButton }">
        <a class="page-link" href="javascript:void(0);" @click="next">{{$lang.Common.DataTable.Next}}</a>
      </li>
    </ul>
  </nav>
</template>

<script>
import { useReactiveModelMixin } from '../../mixins'

const reactiveValueMixin = useReactiveModelMixin(
  'value',
  {
    type: Number,
    required: false
  }
)

export default {
  name: 'NxDataGridPager',
  mixins: [
    reactiveValueMixin
  ],
  props: {
    totalPages: {
      type: Number,
      required: false
    }
  },
  computed: {
    currentPage: {
      get () {
        return this.localValue
      },
      set (value) {
        this.localValue = value
      }
    },
    nextPage () {
      return this.currentPage + 1
    },
    disableNextButton: function () {
      return this.currentPage >= this.totalPages
    },
    disablePreviousButton: function () {
      return this.currentPage <= 1
    },
    previousPage () {
      return this.currentPage - 1
    }
  },
  methods: {
    canShowPage (page) {
      const firstPage = 1
      const lastPage = this.totalPages

      const offset = 2
      const currentPage = this.currentPage

      let nextOffset = currentPage + offset
      let previousOffset = currentPage - offset

      if (previousOffset < offset) nextOffset += offset - previousOffset
      if (nextOffset >= lastPage) previousOffset -= (nextOffset - lastPage) + 1

      if (page === firstPage || page === lastPage || page === currentPage) {
        return true
      } else if (page > currentPage && page <= nextOffset) {
        return true
      } else if (page < currentPage && page >= previousOffset) {
        return true
      }

      return false
    },
    next () {
      this.currentPage = this.nextPage
    },
    previous () {
      this.currentPage = this.previousPage
    },
    to (page) {
      this.currentPage = page
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/nexum/components/datagrid/NxDataGridPager.vue